import type { TranslationDictionary } from "../types";

export const es = {
    common: {
        save: "Guardar",
        saving: "Guardando...",
        saved: "Guardado",
        cancel: "Cancelar",
        delete: "Eliminar",
        actions: "Acciones",
        signOut: "Cerrar sesión",
        email: "Correo electrónico",
        password: "Contraseña",
        name: "Nombre",
        organisation: "Organización",
        optional: "(opcional)",
        upload: "Subir",
        uploading: "Subiendo…",
        create: "Crear",
        close: "Cerrar",
        search: "Buscar",
        loading: "Cargando...",
        rename: "Renombrar",
        share: "Compartir",
        errorTryAgain: "Ocurrió un error. Por favor, inténtalo de nuevo.",
        assistant: "Asistente",
        edit: "Editar",
        confirm: "Confirmar",
    },

    sidebar: {
        assistant: "Asistente",
        projects: "Proyectos",
        tabularReview: "Revisión Tabular",
        laura: "LAURA",
        workflows: "Flujos de trabajo",
        accountSettings: "Configuración de cuenta",
        assistantHistory: "Historial del asistente",
        noChatsYet: "Sin conversaciones aún",
        openSidebar: "Abrir barra lateral",
        closeSidebar: "Cerrar barra lateral",
    },

    projects: {
        title: "Proyectos",
        searchPlaceholder: "Buscar proyectos…",
        tabAll: "Todos",
        tabMine: "Míos",
        tabSharedWithMe: "Compartidos conmigo",
        colName: "Nombre",
        colCm: "CM",
        colFiles: "Archivos",
        colChats: "Conversaciones",
        colTabularReviews: "Revisiones tabulares",
        colCreated: "Creado",
        emptyDescription:
            "Sube documentos a proyectos para iniciar conversaciones y revisiones tabulares.",
        createNew: "+ Crear nuevo",
        couldNotLoad: "No se pudieron cargar los proyectos.",
        noTabProjects: "Sin proyectos {tab}",
        newProjectTitle: "Proyectos › Nuevo proyecto",
        projectName: "Nombre del proyecto",
        addCmNumber: "Agregar número CM...",
        selectProject: "Seleccionar proyecto…",
        noProjectsFound: "No se encontraron proyectos",
    },

    assistant: {
        greeting: "Hola, {username}",
        disclaimer:
            "La IA puede cometer errores. Las respuestas no son asesoramiento legal.",
    },

    account: {
        profileTitle: "Perfil",
        displayName: "Nombre de pantalla",
        displayNamePlaceholder: "Ingresa tu nombre",
        organisationLabel: "Organización",
        organisationPlaceholder: "Ingresa tu organización",
        emailLabel: "Correo electrónico",
        usagePlanTitle: "Plan de uso",
        actionsTitle: "Acciones",
        dangerZoneTitle: "Zona de peligro",
        dangerZoneDesc:
            "Eliminar permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.",
        deleteAccount: "Eliminar cuenta",
        confirmDeleteQuestion:
            "¿Estás seguro? Esto eliminará permanentemente tu cuenta.",
        deleting: "Eliminando…",
        languageTitle: "Idioma",
        languageLabel: "Idioma de pantalla",
        modelsTitle: "Modelos",
    },

    auth: {
        logInTitle: "Iniciar sesión",
        logIn: "Iniciar sesión",
        signUp: "Registrarse",
        createAccountTitle: "Crear cuenta",
        emailPlaceholder: "Ingresa tu correo electrónico",
        passwordLabel: "Contraseña",
        passwordPlaceholder: "Ingresa tu contraseña",
        createPasswordPlaceholder: "Crea una contraseña (mín. 6 caracteres)",
        confirmPasswordLabel: "Confirmar contraseña",
        confirmPasswordPlaceholder: "Confirma tu contraseña",
        namePlaceholder: "Tu nombre",
        organisationPlaceholder: "Tu organización",
        passwordsMustMatch: "Las contraseñas no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        accountCreatedTitle: "¡Cuenta creada!",
        accountCreatedRedirecting: "Redirigiendo a la página principal...",
        loggingIn: "Iniciando sesión...",
        creatingAccount: "Creando cuenta...",
        demoDisclaimer:
            "Mike en AuditFlow.com es actualmente un servicio de demostración. Por favor, no suba, envíe ni almacene documentos sensibles, confidenciales, privilegiados, de clientes o con datos personales identificables.",
        termsPrefix: "Al registrarte, aceptas nuestros",
        termsLink: "Términos de uso",
        privacyLink: "Política de privacidad",
        termsConjunction: "y",
    },

    modals: {
        deleteChatsTitle: "Eliminar todas las conversaciones",
        deleteChatsConfirm:
            "¿Estás seguro de que deseas eliminar {count} {chatWord}? Esta acción es permanente y no se puede deshacer.",
        deleteChatsButton: "Eliminar todas las conversaciones",
        deletingChats: "Eliminando...",
        allChatsDeletedTitle: "Conversaciones eliminadas",
        allChatsDeletedDesc:
            "Tu historial de conversaciones se ha eliminado correctamente.",
        chat_one: "conversación",
        chat_other: "conversaciones",
        ownerOnlyTitle: "Solo para propietarios",
        ownerOnlyDesc:
            "Solo puedes {action}. Contacta al propietario del proyecto para acceder.",
        dismiss: "Cerrar",
        apiKeyMissingTitle: "Se requiere clave API",
        copyLink: "Copiar enlace",
        linkCopied: "¡Copiado!",
        shareLink: "Compartir enlace",
        creditsTitle: "Límite de mensajes alcanzado",
        creditsBody: "Has alcanzado tu límite mensual de 100 mensajes.",
        creditsReset: "Tus créditos se restablecerán el:",
        creditsInfo: "Tus créditos de mensajes se restablecen automáticamente el primer día de cada mes.",
    },

    tabular: {
        newReviewPlaceholder: "Nombre de la revisión",
        workflowTemplate: "Plantilla de flujo de trabajo",
        loadingTemplates: "Cargando plantillas…",
        noTemplate: "Sin plantilla — empezar desde cero",
        createUnderProject: "Crear en un proyecto",
        selectDocuments: "Seleccionar documentos",
        projectDocuments: "Documentos del proyecto",
        documents: "Documentos",
        noReadyDocs: "No hay documentos listos en este proyecto",
        noDocs: "Aún no hay documentos",
        tabularReviews: "Revisiones tabulares",
        newReview: "Nueva revisión",
        generate: "Generar",
        generating: "Generando…",
        addColumn: "+ Agregar columna",
        addDocuments: "+ Agregar documentos",
        clearAll: "Limpiar todo",
        exportExcel: "Exportar a Excel",
        flag: "Indicador",
        results: "Resultados",
        reasoning: "Razonamiento",
        regenerate: "Regenerar",
        columnName: "Nombre de columna",
        columnPrompt: "Indicación",
        columnFormat: "Formato",
        saveColumn: "Guardar",
        deleteColumn: "Eliminar columna",
        noColumns: "Aún no hay columnas",
        noDocuments: "Sin documentos",
        statusPending: "Pendiente",
        statusGenerating: "Generando",
        statusDone: "Listo",
        statusError: "Error",
        run: "Ejecutar",
        running: "Ejecutando…",
        export: "Exportar",
        assistantInTabular: "Asistente en revisión tabular",
        clearResults: "Limpiar resultados",
        addColumns: "Agregar columnas",
        columnsSelected: "{count} columnas seleccionadas",
        runColumn: "Ejecutar columna",
        runSelectedColumnsHint: "Ejecutar columnas seleccionadas en todos los documentos (o filas seleccionadas)",
        runSelectedRowsHint: "Ejecutar todas las columnas pendientes en los documentos seleccionados",
        searchDocuments: "Buscar documentos…",
        untitledReview: "Revisión sin título",
        tabularReview: "Revisión tabular",
        editColumn: "Editar columna",
        newColumn: "Nueva columna",
        noPreset: "Sin plantilla",
        tags: "Etiquetas",
        addTag: "Agregar etiqueta…",
        addTagHint: "Presiona Enter o coma para agregar una etiqueta.",
        autoGeneratePrompt: "Generar indicación automáticamente",
        columnPromptPlaceholder: "Escribe la indicación de análisis — describe qué debe extraer AuditFlow de cada documento para esta columna…",
        addAnotherColumn: "Agregar otra columna",
        saveChanges: "Guardar cambios",
        thinking: "Pensando…",
        pondering: "Reflexionando…",
        analyzing: "Analizando…",
        reasoningVerb: "Razonando…",
        thoughtProcess: "Proceso de pensamiento",
        reading: "Leyendo",
        read: "Leído",
        chatPlaceholder: "Haz una pregunta sobre tus documentos...",
        chatHistory: "Historial de chat",
        newChat: "Nuevo chat",
        deleteChat: "Eliminar chat",
        askQuestion: "Haz una pregunta sobre esta revisión tabular.",
        searchChats: "Buscar chats…",
        noPreviousChats: "Sin chats anteriores.",
        noMatches: "Sin resultados.",
        chatFallback: "Chat",
    },

    workflows: {
        title: "Flujos de trabajo",
        searchPlaceholder: "Buscar flujos de trabajo…",
        tabAll: "Todos los flujos",
        tabBuiltin: "Integrados",
        tabCustom: "Personalizados",
        tabHidden: "Ocultos",
        newWorkflow: "Nuevo flujo de trabajo",
        importWorkflows: "Importar",
        colName: "Nombre",
        colType: "Tipo",
        colCreator: "Creador",
        typeAssistant: "Asistente",
        typeTabular: "Tabular",
        builtIn: "Integrado",
        noWorkflows: "No se encontraron flujos de trabajo",
        workflowName: "Nombre del flujo de trabajo",
        workflowPrompt: "Indicación del sistema",
        practiceArea: "Área de práctica",
        allPractices: "Todas",
        allTypes: "Todos los tipos",
        hide: "Ocultar",
        unhide: "Mostrar",
        colPractice: "Área",
        colSource: "Fuente",
        filterByType: "Filtrar por tipo",
        filterByPractice: "Filtrar por práctica",
        customWorkflowsTitle: "Flujos personalizados",
        customWorkflowsDesc: "Crea indicaciones reutilizables y plantillas de revisión tabular adaptadas a tu práctica.",
        hiddenWorkflowsTitle: "Flujos ocultos",
        hiddenWorkflowsDesc: "Los flujos integrados que has ocultado aparecerán aquí. Puedes mostrarlos en cualquier momento.",
        emptyDesc: "Automatiza el análisis de documentos con indicaciones reutilizables y plantillas de revisión tabular.",
        myCreation: "Yo mismo",
        sharedFallback: "Compartido",
        importTitle: "Importar flujos desde JSON",
        editWorkflow: "Editar flujo",
        practiceAreaPlaceholder: "Ingresa el área de práctica…",
        creating: "Creando…",
        saving: "Guardando…",
        createWorkflow: "Crear flujo de trabajo",
        selectWorkflow: "Seleccionar flujo",
        newChatBreadcrumb: "Nuevo chat",
        newReviewBreadcrumb: "Nueva revisión",
        viewPage: "Ver página",
        edit: "Editar",
        use: "Usar",
        additionalMessage: "Mensaje (opcional)",
        additionalMessagePlaceholder: "Agrega instrucciones adicionales a la indicación del flujo…",
        createInProject: "Crear en un proyecto",
        selectProjectLabel: "Seleccionar proyecto",
        selectDocumentsLabel: "Seleccionar documentos",
        noMatchesFound: "Sin resultados",
        noDocsInProject: "No hay documentos en este proyecto",
        selectedCount: "{count} seleccionados",
        startingChat: "Iniciando…",
        startChat: "Iniciar chat",
        createReview: "Crear revisión",
        workflowPromptLabel: "Indicación del flujo",
        columnsLabel: "Columnas",
        noColumnsDefined: "Sin columnas definidas",
    },

    shared: {
        addDocuments: "Agregar documentos",
        uploadFiles: "Subir archivos",
        noDocumentsAvailable: "No hay documentos disponibles",
        people: "Personas",
        shareWith: "Compartir con",
        addByEmail: "Agregar por correo electrónico…",
        owner: "Propietario",
        viewer: "Visualizador",
        removeAccess: "Eliminar acceso",
        versionUploadTitle: "Subir nueva versión",
        versionFile: "Archivo",
        versionNote: "Nota de versión",
        versionNotePlaceholder: "¿Qué cambió en esta versión?",
        uploading: "Subiendo…",
        uploadVersion: "Subir versión",
        peopleWithAccess: "Personas con acceso",
        noOneHasAccess: "Nadie tiene acceso todavía.",
        remove: "Quitar",
        versionNameLabel: "Nombre de la nueva versión",
        versionCurrentLabel: "Versión actual",
        versionNewFileLabel: "Archivo de nueva versión",
        changeFile: "Cambiar archivo",
        newSubfolder: "Nueva subcarpeta",
        download: "Descargar",
        showAllVersions: "Mostrar todas las versiones",
        uploadNewVersion: "Subir nueva versión",
        removeFromFolder: "Quitar de subcarpeta",
        editCmNumber: "Editar N.º CM",
    },

    laura: {
        title: "Auditorías LAURA",
        newAudit: "Nueva auditoría",
        empty: "Aún no hay auditorías. Cree una para iniciar el ciclo P0–E8.",
        projectRequired: "Abra un proyecto para crear una auditoría LAURA.",
        p0Title: "P0 — Contextualización del caso",
        p0Phase: "Fase",
        p0PhasePlanning: "PLANIFICACIÓN",
        p0Step: "Etapa",
        p0Progress: "Progreso",
        p0Deliverable: "Entregable",
        p0DeliverablePending: "Briefing inicial pendiente",
        p0DeliverableDone: "Briefing inicial",
        p0ContextTitle: "Contexto inicial",
        p0SelectDocs: "Documentos del proyecto",
        p0SelectDocsHint: "Seleccione al menos un documento para generar preguntas.",
        p0InitialComments: "Comentarios iniciales (opcional)",
        p0InitialCommentsPlaceholder:
            "Describa el caso, motivación de la auditoría, hipótesis…",
        p0LinkedDocs: "Documentos vinculados",
        p0GenerateQuestions: "Generar preguntas",
        p0GenerateBriefing: "Generar briefing inicial",
        p0Generating: "Generando…",
        p0QuestionsTitle: "Preguntas de aclaración",
        p0QuestionsEmpty: 'Haga clic en "Generar preguntas" tras vincular documentos.',
        p0BriefingTitle: "Briefing inicial del caso",
        p0BriefingEmpty:
            'Complete todas las respuestas y haga clic en "Generar briefing inicial".',
        p0ValidationTitle: "Puntos de validación antes de avanzar a P1",
        p0ValidationEmpty: "Los puntos aparecerán tras generar el briefing.",
        p0WaitingAnswer: "En espera…",
        p0CategoryObjeto: "Objeto y contexto",
        p0CategoryEscopo: "Tipo y alcance",
        p0CategoryProblema: "Problema y objetivos",
        p0CategoryRecursos: "Recursos y restricciones",
        p0CategoryComplementar: "Información complementaria",
        p0InvalidateTitle: "¿Cambiar contexto?",
        p0InvalidateMessage:
            "Esto invalidará preguntas, respuestas y el briefing generados. ¿Continuar?",
        p0InvalidateConfirm: "Continuar",
        p0InvalidateCancel: "Cancelar",
        p0ChatHint:
            "Use el chat para dudas o ajustes de secciones del briefing. Las preguntas solo se completan en el formulario.",
        p0ChatEmpty:
            "Para iniciar una auditoría: vincule documentos, añada comentarios opcionales y pulse Generar preguntas.",
        p0ApprovedAt: "Aprobado el {date} por {user}",
        p0SaveComments: "Guardar comentarios",
        p0WorkflowTitle: "Flujo P0 — siga estos pasos en orden",
        p0Step1Help: "Seleccione documentos relevantes del proyecto en Contexto inicial.",
        p0Step2Help: "Opcional: añada comentarios iniciales sobre el caso.",
        p0Step3Help: "Guarde los comentarios (o se guardan al salir del campo).",
        p0Step4Help: "Pulse Generar preguntas.",
        p0Step5Help: "Responda todas las preguntas de aclaración en el panel izquierdo.",
        p0Step6Help: "Pulse Generar briefing inicial y revíselo o edítelo.",
        p0Step7Help:
            "Marque todos los puntos de validación y luego Aprobar y avanzar abajo.",
        p0ContextExpand: "Mostrar contexto inicial",
        p0ContextCollapse: "Ocultar contexto inicial",
        p0ContextSummary:
            "Contexto inicial · {count} documento(s) · comentarios {commentsStatus}",
        p0CommentsSaved: "guardados",
        p0CommentsUnsaved: "sin guardar",
        p0ApproveStep: "Paso final",
        p0ApproveAndAdvance: "Aprobar y avanzar",
        dashboardTitle: "Panel LAURA",
        statActive: "Auditorías activas",
        statInProgress: "Planificación en curso",
        statPlanningDone: "Planificación completada",
        statPending: "En fase de planificación",
        planningProgress: "Progreso de planificación",
        planningProgressStep: "Paso {current} de {total}",
        tabInputs: "Entradas",
        tabValidation: "Validación",
        validationPending: "QA humano pendiente",
        validationHint: "Confirme cada punto antes de aprobar esta etapa.",
        validationEmpty: "Sin puntos de validación aún",
        validationGenerateHint: "Genere el entregable con IA para poblar los puntos de validación.",
        createSampleAudit: "Crear auditoría ejemplo NHAI",
        seedingAudit: "Cargando datos de ejemplo…",
        lastUpdated: "Última actualización",
        saveForm: "Guardar formulario",
        saveDeliverable: "Guardar entregable",
        deliverable: "Entregable",
        validationTitle: "Puntos de validación",
        p1Title: "P1 — Canvas de auditoría",
        p2Title: "P2 — Visión general del objeto",
        p3Title: "P3 — Matriz de riesgos",
        p4Title: "P4 — Matriz de planificación",
        p5Title: "P5 — Instrumentos de recolección",
        p6Title: "P6 — Plan de auditoría",
        p7Title: "P7 — Supervisión y calidad",
        generateCanvas: "Generar canvas",
        generateOverview: "Generar visión general",
        generateRisks: "Generar matriz de riesgos",
        generateMatrix: "Generar matriz de planificación",
        generateInstruments: "Generar instrumentos",
        generatePlan: "Generar plan de auditoría",
        generateQuality: "Generar revisión de calidad",
        addRisk: "Agregar riesgo",
        mandatoryGate: "Puerta obligatoria — aprobación del supervisor antes de E0",
        executiveSummary: "Resumen ejecutivo",
        financialBenefits: "Beneficios financieros",
        nonFinancialBenefits: "Beneficios no financieros",
        p1_subject: "Objeto",
        p1_criteria: "Criterios",
        p1_evidence: "Estrategia de evidencias",
        p1_problem: "Problema de auditoría",
        p1_stakeholders: "Stakeholders",
        p1_assurance: "Nivel de aseguramiento",
        p1_objective: "Objetivo SMART",
        p1_outOfScope: "Fuera de alcance",
        p1_scope: "Alcance",
        p1_engRisks: "Riesgos del encargo",
        p1_deliverables: "Entregables",
        p1_timeline: "Cronograma",
        p1_benefits: "Beneficios esperados",
        p2_mandate: "Propósito y base legal",
        p2_financialChart: "Tendencia financiera",
        p2_swot: "Análisis FODA",
        p2_org: "Estructura organizacional",
        p2_process: "Mapa de procesos",
    },
} satisfies TranslationDictionary;
